export const authenticationMethodTypesMap = {
  INTERNAL: 1,
  LDAP: 2,
  OAUTH: 3,
};

export const authenticationMethodTypesLabels = {
  [authenticationMethodTypesMap.INTERNAL]: 'Внутренняя',
  [authenticationMethodTypesMap.LDAP]: 'LDAP',
  [authenticationMethodTypesMap.OAUTH]: 'OAuth',
};
